<ds-item-page-cc-license-field
  [item]="item"
  [variant]="'full'"
  [ccLicenseUriField]="dcRightsUri"
  [ccLicenseNameField]="dcRights"
  [showLabel]="false"
  [showUrl]="true">
</ds-item-page-cc-license-field>
